<template>
  <v-navigation-drawer
    :value="isOpenImageOwner"
    :permanent="isOpenImageOwner"
    :width="windowSize.x > 800 ? '800px' : '100vw'"
    max-width="100vw"
    temporary
    fixed
    right
    color="grey lighten-3"
    style="z-index: 16;transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);"
  >
    <v-card min-height="100vh" color="grey lighten-3">
      <BaseToolbar
        ref="base-toolbar"
        :dark="false"
        @close="close"
        :title="$t('images.gallery.title')"
        type-title="icon"
        color="white"
      >
        <div class="d-flex align-center mr-5">
          <v-btn
            ref="button-add-image"
            @click="pickFile()"
            :loading="submitFilesLoading"
            color="primary"
            depressed
            tile
          >
            {{ $t('actions.add') }}
          </v-btn>
        </div>
        <!-- <v-menu bottom right min-width="150px">
          <template v-slot:activator="{ on }">
            <v-btn ref="item-menu-button-open" v-on="on" :loading="submitFilesLoading" text>
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item ref="button-menu-images-add" @click="pickFile()">
              <v-list-item-title>
                {{ $t('actions.add') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item ref="button-menu-images-gallery" @click="toggleImageGallery(true)">
              <v-list-item-title>
                {{ $t('common.gallery') }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu> -->
      </BaseToolbar>
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
        absolute
        style="top: 64px;"
      />
      <v-card-text style="position: relative; overflow-y: auto;height: calc(100vh - 64px)">
        <v-container>
          <v-row class="mb-5">
            <v-col cols="12" class="d-flex align-center">
              <div v-html="$t('images.owner.text')" />
            </v-col>
            <!-- <v-col cols="12" sm="4" md="3" class="d-flex align-center">
              <v-btn
                ref="button-open-gallery"
                @click="toggleImageGallery(true)"
                color="primary"
                depressed
                tile
                class="mr-1"
                block
              >
                {{ $t('images.gallery.title') }}
              </v-btn>
            </v-col> -->
          </v-row>
          <v-row>
            <v-col v-if="!gallery.length" cols="12">
              <div class="text-center pa-12 my-12">
                <v-img
                  :src="require('@/assets/svg/box_empty.svg')"
                  height="150"
                  max-height="150px"
                  aspect-ratio="1"
                  contain
                />
                <div class="grey--text">
                  {{ $t('common.no_results_found') }}
                </div>
              </div>
            </v-col>
            <v-col
              v-for="(item, index) in gallery"
              :key="index"
              cols="12"
              sm="6"
              md="4"
            >
              <v-card hover outlined>
                <v-img
                  :src="item.url"
                  :lazy-src="item.url"
                  contain
                  height="200"
                  class="grey lighten-2"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular indeterminate color="grey lighten-5" />
                    </v-row>
                  </template>
                </v-img>
                <v-card-text style="height: calc(100% - 244px);">
                  <v-row dense>
                    <v-col cols="12" class="text-truncate">
                      {{ item.name }}
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    ref="image-card-button-copy"
                    icon
                    small
                    class="pa-0 ma-0"
                  >
                    <v-icon @click="copyText(item.url)" small>
                      file_copy
                    </v-icon>
                  </v-btn>
                  <v-btn
                    ref="image-card-button-copy"
                    icon
                    small
                    class="pa-0 ma-0"
                  >
                    <v-icon @click="setEditImage(item)" small>
                      edit
                    </v-icon>
                  </v-btn>
                  <v-btn
                    ref="image-card-button-remove"
                    @click="openRemoveImageDialog(item.id)"
                    icon
                    small
                    class="pa-0 ma-0"
                  >
                    <v-icon size="20px">
                      delete
                    </v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <div v-if="totalGallery > gallery.length" v-intersect="onIntersect" class="intersector" />
      </v-card-text>
    </v-card>
    <input ref="copyText" v-model="copyTextField" type="hidden">
    <input
      ref="image"
      @change="onFilePicked"
      type="file"
      style="display: none"
      accept="image/*"
    >
    <BaseConfirmDialog
      ref="base-confirm-dialog"
      v-if="removeImageDialog.display && removeImageDialog.imageId"
      :cancel-text="$t('actions.cancel')"
      :accept-text="$t('actions.remove')"
      @close="closeRemoveImageDialog()"
      @proceed="confirmRemoveImage()"
      :title="$t('images.remove.title')"
      :description="$t('images.remove.text')"
      :submit-loading="removeImageDialog.loading"
    />
    <ImageEditor />
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import BaseToolbar from '@/components/BaseToolbar'
import BaseConfirmDialog from '@/components/BaseConfirmDialog'
import ImageEditor from '@/components/Images/Editor'

export default {
  name: 'ImageOwner',
  components: {
    BaseToolbar,
    BaseConfirmDialog,
    ImageEditor
  },
  data () {
    return {
      loading: false,
      submitFilesLoading: false,
      copyTextField: null,
      removeImageDialog: {
        display: false,
        imageId: null,
        loading: false
      },
      pagination: {
        page: 1,
        itemsLength: 0,
        itemsPerPage: 12,
        itemsPerPageOptions: [
          { value: 4, text: 4 },
          { value: 8, text: 8 },
          { value: 12, text: 12 },
          { value: 24, text: 24 }
        ],
        sortBy: 'name',
        sortDesc: false
      }
    }
  },
  watch: {
    isOpenImageOwner (newVal) {
      if (newVal) {
        this.getData()
      }
    }
  },
  computed: {
    ...mapGetters({
      windowSize: 'windowSize',
      gallery: 'images/gallery',
      totalGallery: 'images/totalGallery',
      isOpenImageOwner: 'images/isOpenImageOwner'
    }),
    computedPagination () {
      const { pagination } = this
      pagination.itemsLength = this.totalGallery
      return pagination
    }
  },
  methods: {
    ...mapActions({
      getGallery: 'images/getGallery',
      saveImage: 'images/saveImage',
      removeImage: 'images/removeImage'
    }),
    ...mapMutations({
      toggleImageOwner: 'images/toggleImageOwner',
      toggleImageGallery: 'images/toggleImageGallery',
      toggleImageEditor: 'images/toggleImageEditor',
      setImage: 'images/setImage'
    }),
    handlerInput (arg) {
      if (!arg) { this.close() }
    },
    async getData () {
      const {
        search,
        computedPagination
      } = this
      this.loading = true
      await this.getGallery({
        search,
        page: computedPagination.page,
        rowsPerPage: computedPagination.itemsPerPage,
        sortBy: computedPagination.sortBy,
        descending: computedPagination.sortDesc
      })
      this.loading = false
    },
    cleanData () {
      this.loading = false
      this.submitFilesLoading = false
      this.copyTextField = null
      this.removeImageDialog = {
        display: false,
        imageId: null,
        loading: false
      }
      this.pagination = {
        page: 1,
        itemsLength: 0,
        itemsPerPage: 12,
        itemsPerPageOptions: [
          { value: 4, text: 4 },
          { value: 8, text: 8 },
          { value: 12, text: 12 },
          { value: 24, text: 24 }
        ],
        sortBy: 'name',
        sortDesc: false
      }
    },
    close () {
      this.toggleImageOwner(false)
      this.cleanData()
    },
    openRemoveImageDialog (id) {
      this.removeImageDialog.display = true
      this.removeImageDialog.imageId = id
    },
    closeRemoveImageDialog () {
      this.removeImageDialog.display = false
      this.removeImageDialog.loading = false
      this.removeImageDialog.imageId = null
    },
    async confirmRemoveImage () {
      this.removeImageDialog.loading = true
      await this.removeImage({ id: this.removeImageDialog.imageId })
      this.closeRemoveImageDialog()
    },
    setEditImage (image) {
      this.setImage(image)
      this.toggleImageEditor(true)
    },
    pickFile () {
      this.$refs.image.click()
    },
    onFilePicked (e) {
      const { files } = e.target
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        const { name, size, type } = file
        const fr = new FileReader()
        if (file !== undefined) {
          if (size < 1000000) {
            fr.readAsDataURL(file)
            fr.addEventListener('load', async () => {
              this.submitFilesLoading = true
              await this.saveImage({
                path: `templates`,
                name,
                size,
                type,
                content: fr.result
              })
              this.submitFilesLoading = false
            })
          } else {
            this.$noty.error(this.$i18n.t('reports.message.errors.fileSize', null, { size: '1' }))
          }
        }
      }
    },
    async copyText (text) {
      this.copyTextField = text
      const textToCopy = this.$refs.copyText
      await textToCopy.setAttribute('type', 'text')
      textToCopy.select()
      try {
        const successful = document.execCommand('copy')
        successful
          ? this.$noty.success(this.$t('images.messages.success.copy'))
          : this.$noty.error(this.$t('images.messages.error.copy'))
      } catch (error) {
        this.$noty.error(this.$t('images.messages.error.copy'))
      }
      this.copyTextField = ''
      textToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    }
  }
}
</script>
